import { defineRouting } from "next-intl/routing";

export type Locale = (typeof locales)[number];

export const locales = ["en", "vi", "th", "id", "ko", "ja"] as const;
export const defaultLocale: Locale = "en";

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: { mode: "as-needed" },
});
